import qcAtkingPlayersStore from "../store/qcAtkingPlayers";


const useQcAtkingPlayers = (playerId) => {
    const atkingPlayers = qcAtkingPlayersStore((state) => state.atkingPlayers);
    const setAtkingPlayer = qcAtkingPlayersStore((state) => state.setAtkingPlayer);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        atkingPlayer: playerId == null ? {} : atkingPlayers[playerId] ?? {},
        atkingPlayers,
        setAtkingPlayer
    };
};

export default useQcAtkingPlayers;
